'use strict'

var caseSensitiveTransform = require('./case-sensitive-transform')

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/case-insensitive-transform.js
// module id = 421
// module chunks = 35783957827783 241767136424496